import type {
  ApiPermissionItem,
  PermissionCatalogItem,
} from "@/core/administration/entities/PermissionCatalog";

export default class PermissionCatalogMapper {
  static toDomainItem(api: ApiPermissionItem): PermissionCatalogItem {
    return {
      id: `${api.domaine}:${api.action}:${api.ressource}`,
      domain: api.domaine,
      action: api.action,
      resource: api.ressource,
      label: api.name,
      criticality: undefined,
    };
  }

  static toDomainItems(apiItems: ApiPermissionItem[]): PermissionCatalogItem[] {
    return apiItems.map((item) => PermissionCatalogMapper.toDomainItem(item));
  }
}
